import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MixpanelService } from '@core/services';
import { EllipsisTooltipComponent } from '@shared/components';
import { TooltipFocusHandlerDirective } from '@shared/directives/tooltip-focus-handler.directive';
import { AppRoutes } from '@shared/helpers';
import { ButtonModule } from 'primeng/button';
import { DashboardResultsColumnEnum } from 'src/app/features/dashboard/_core/enums/dashboard-results-column.enum';
import { DashboardTableColumn } from 'src/app/features/dashboard/_core/interfaces';
import { DashboardResult } from 'src/app/features/dashboard/_core/interfaces/dashboard-results.interface';
import { ResultsDownloadApi } from 'src/app/features/orders/_shared/_core/api';
import { FileExtensionEnum } from 'src/app/features/orders/_shared/_enums';

@Component({
    selector: '[app-results-table-row]',
    standalone: true,
    imports: [DatePipe, EllipsisTooltipComponent, ButtonModule, RouterModule, TooltipFocusHandlerDirective],
    templateUrl: './results-table-row.component.html',
    styleUrls: ['./results-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsTableRowComponent {
    readonly columns = input.required<DashboardTableColumn<DashboardResultsColumnEnum>[]>();
    readonly result = input.required<DashboardResult>();

    readonly orderAbstractRoute = computed(() => AppRoutes.routes().ORDERS_ABSTRACT_RESULTS(this.result().orderId));

    readonly isDownloadingResult = signal(false);

    readonly dashboardResultsColumnEnum = DashboardResultsColumnEnum;
    readonly fileExtensionEnum = FileExtensionEnum;

    constructor(
        private mixpanelService: MixpanelService,
        private resultsDownloadApi: ResultsDownloadApi
    ) {}

    async downloadResults() {
        this.isDownloadingResult.set(true);
        this.mixpanelService.logEvent('dashboard-order-results-download-results-files', {
            orderId: this.result().orderId,
        });

        await this.resultsDownloadApi.downloadAllOrderResults(this.result().orderId);
        this.isDownloadingResult.set(false);
    }

    logOrderNameClick() {
        this.mixpanelService.logEvent('dashboard-order-result-redirect', {
            orderId: this.result().orderId,
        });
    }
}
